import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { XtrasService } from "./xtras.service";
import { HttpService } from "./http.service";
import { SettingsProvider } from "./settings";

interface AuthData {
    token: string,
    expiresAt?: string,
    user?: {
        id: number|string,
        name: string,
        email: string,
        image?: string,
        cellphone?: string|number,
        birth_date?: string|Date,
        country_identity?: string|number,
        enable_card: boolean,
        profile?: Profile,
    },
    guest: boolean,
}

interface Profile {
    id: number|string,
    first_name: string,
    last_name: string,
    email: string,
    image?: string,
    cellphone?: string|number,
    birth_date?: string|Date,
    country_identity?: string|number,
    [key: string]: any,
}

@Injectable({
	providedIn: 'root'
})
export class AuthService {

    private _auth = new BehaviorSubject<AuthData|undefined>(undefined);
	auth$ = this._auth.asObservable();

	get authValue(): AuthData|undefined {
		return this._auth.value;
	}
	set authValue(auth: AuthData|undefined) {
		this._auth.next(auth);
	}

    constructor(
        private router: Router,
        private xServices: XtrasService,
        private http: HttpService,
    ) {}

    getToken(): string|undefined {
		let auth:any = localStorage.getItem('auth') || undefined;
		if(auth && auth != '') {
            let _auth = this.xServices.filterEmptyParams(JSON.parse(auth));
			return (_auth['token'] ?? undefined);
		} else {
			return undefined;
		}
	}

    getAuth(): AuthData|undefined {
		let auth:any = localStorage.getItem('auth') || undefined;
		if(auth && auth != '') {
            let _auth = this.xServices.filterEmptyParams(JSON.parse(auth));
            if(!_auth['token']) return undefined;
			return {
                token: _auth['token'],
                expiresAt: _auth['expiresAt'] ?? undefined,
                user: _auth['user'] ?? undefined,
                guest: _auth['guest'] ?? false,
            };
		} else {
			return undefined;
		}
	}

    saveAuth(token: string, expiresAt?: string, user?: any, guest?: boolean, redirect?: string) {
        let auth: AuthData = {
            token: token,
            expiresAt: (expiresAt ?? undefined),
            user: (user ?? undefined),
            guest: (guest ?? false),
        };
        let _auth = this.xServices.filterEmptyParams(auth);

        localStorage.setItem('auth', JSON.stringify(_auth));
        if(redirect) {
            this.router.navigateByUrl(redirect, {
                replaceUrl: true
            });
        }
    }

    clearAuth() {
        this.authValue = undefined;
        localStorage.removeItem('auth');
    }

    logout() {
        this.clearAuth();
        this.router.navigateByUrl('/login');
        // location.reload();
    }

    userData(user?: AuthData) {
		if (!user) {
		  	this.logout();
		}
		return user;
	}

    getUserByToken(): Promise<AuthData|undefined> {
        return new Promise(async (resolve) => {
            try {
                const auth = this.getAuth();
                if (!auth || !auth.token) {
                    this.authValue = undefined;
                    return resolve(undefined);
                }
                // if(auth!.guest) {
                //     this.authValue = auth;
                //     resolve(this.userData(auth));
                // }
          
                const data = await this._getUserByToken();
                if (data['data']) {
                    let _data = data['data'];
                    let userData: AuthData['user'] = {
                        id:         _data['id'] ?? 0,
                        name:       _data['name'] ?? 'Nombre',
                        email:      _data['email'] ?? 'email',
                        image:      _data['image'] ?? undefined,
                        cellphone:  _data['cellphone'] ?? undefined,
                        birth_date: _data['birth_date'] ?? undefined,
                        enable_card: _data['enable_card'] ?? false,
                        profile:    _data['profile'] ?? undefined,
                    };
                    let currentUser: AuthData = { ...auth!, user: userData };
                    this.authValue = currentUser;
                    this.saveAuth(
                        currentUser.token, 
                        currentUser.expiresAt, 
                        userData, 
                        currentUser.guest
                    );
                    return resolve(this.userData(currentUser));
                }
          
                this.authValue = undefined;
                return resolve(this.userData(undefined));
            } catch (err) {
                console.log('errorAuth', err);
                this.authValue = undefined;
                return resolve(this.userData(undefined));
            }
        });
	}

    private async _getUserByToken(): Promise<any> {
		return this.http.get_request(SettingsProvider.endpoints.account, undefined, true, true).toPromise();
	}
}
